import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { getEntries } from "../../api/commands/entries";
import {
	checkProfileImageExists,
	editRecord,
	getRecord,
	getRecords,
	importProfileImageFromUrl,
	lookupRecord,
} from "../../api/commands/records";
import { ApiError } from "../../api/errors";
import * as Picker from "../../widgets/recordPicker";

export const Message = defineMessageUnion({
	CompletedReadPayload: { raw: S.Option(S.String) },
	CompletedLookup: { generation: S.Number, result: lookupRecord.Result },
	CompletedNameSearch: { generation: S.Number, result: getRecords.Result },
	// Per-record completions carry the id they were issued for: a late result
	// for a previous selection must not land on the current one.
	CompletedFetchRecord: {
		nodeId: S.String,
		generation: S.Number,
		result: getRecord.Result,
	},
	CompletedFetchEntries: {
		nodeId: S.String,
		generation: S.Number,
		result: getEntries.Result,
	},
	CompletedCheckImage: {
		nodeId: S.String,
		generation: S.Number,
		result: checkProfileImageExists.Result,
	},
	GotPickerMessage: { message: Picker.Message },
	ClickedNotThisPerson: {},
	ClickedCreate: {},
	/** The created record's id. */
	CompletedCreate: {
		generation: S.Number,
		result: S.Result(S.String, ApiError),
	},
	ClickedLink: {},
	CompletedLink: { generation: S.Number, result: editRecord.Result },
	ClickedSync: {},
	CompletedSyncPatch: { generation: S.Number, result: editRecord.Result },
	CompletedPhoto: {
		nodeId: S.String,
		generation: S.Number,
		result: importProfileImageFromUrl.Result,
	},
	ClickedDismissError: {},
});
export type Message = typeof Message.Type;
